module.exports = __webpack_public_path__ + "img/vf5.3e2fc2a1.png";